import { AnimatePresence, motion } from "framer-motion";
import { CATEGORY } from "../../lib/api";

// Full-screen Twist takeover. Dramatic entrance, requires tap to dismiss.
export function TwistOverlay({ twist, onDismiss, lang = "es" }) {
  const primary = twist ? (lang === "en" ? (twist.en || twist.custom || twist.es) : (twist.es || twist.custom)) : "";
  const secondary = twist ? (lang === "en" ? (twist.es || "") : (twist.en || "")) : "";
  return (
    <AnimatePresence>
      {twist ? (
        <motion.div
          key="twist"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.25 }}
          className="fixed inset-0 z-[100] flex flex-col items-center justify-center bg-dig-harbour text-white px-8 overflow-hidden"
          data-testid="twist-overlay"
          onClick={onDismiss}
        >
          {/* radial flash burst */}
          <motion.div
            initial={{ scale: 0, opacity: 0.7 }}
            animate={{ scale: 3.5, opacity: 0 }}
            transition={{ duration: 0.9, ease: "easeOut" }}
            className="pointer-events-none absolute w-[60vmin] h-[60vmin] rounded-full"
            style={{ background: "radial-gradient(circle, rgba(253,187,47,0.55) 0%, rgba(253,187,47,0) 70%)" }}
          />
          <motion.div
            initial={{ scale: 0.4, rotate: -8, opacity: 0 }}
            animate={{ scale: 1, rotate: 0, opacity: 1 }}
            transition={{ type: "spring", stiffness: 240, damping: 16, delay: 0.08 }}
            className="dig-shake relative flex flex-col items-center text-center max-w-4xl"
          >
            <motion.div
              initial={{ y: -20, opacity: 0 }}
              animate={{ y: 0, opacity: 1 }}
              transition={{ delay: 0.2 }}
              className="flex items-center gap-3 mb-6"
            >
              <img src={CATEGORY.TWIST.icon} alt="" className="w-12 h-12" style={{ filter: "brightness(0) invert(1)" }} />
              <span className="text-dig-yellow font-bold tracking-[0.3em] text-lg">TWIST</span>
            </motion.div>
            <motion.h1
              initial={{ scale: 0.85, opacity: 0 }}
              animate={{ scale: 1, opacity: 1 }}
              transition={{ delay: 0.28, type: "spring", stiffness: 200, damping: 14 }}
              className="font-black text-dig-yellow leading-[0.95] tracking-tight"
              style={{ fontSize: "clamp(2.5rem, 8vw, 6rem)" }}
            >
              {primary}
            </motion.h1>
            {secondary ? (
              <motion.p
                initial={{ y: 12, opacity: 0 }}
                animate={{ y: 0, opacity: 1 }}
                transition={{ delay: 0.42 }}
                className="mt-6 text-white/60 font-light text-lg"
              >
                {secondary}
              </motion.p>
            ) : null}
            {onDismiss ? (
              <motion.button
                initial={{ y: 16, opacity: 0 }}
                animate={{ y: 0, opacity: 1 }}
                transition={{ delay: 0.55 }}
                data-testid="twist-dismiss-btn"
                className="mt-12 rounded-full bg-dig-yellow text-dig-harbour font-bold px-10 py-4 text-lg hover:brightness-95 transition-[filter]"
              >
                {lang === "es" ? "Entendido, seguimos" : "Got it, continue"}
              </motion.button>
            ) : null}
          </motion.div>
        </motion.div>
      ) : null}
    </AnimatePresence>
  );
}
